export default __webpack_public_path__ + "static/media/dune_x_crayon_feat_ichon_2.2249b5ee.png";